export default __webpack_public_path__ + "static/media/gallery_34.2c1ec543.jpg";